import { render, staticRenderFns } from "./PortfolioCreator.vue?vue&type=template&id=b1621bfe&scoped=true&"
import script from "./PortfolioCreator.vue?vue&type=script&lang=js&"
export * from "./PortfolioCreator.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCreator.vue?vue&type=style&index=0&id=b1621bfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1621bfe",
  null
  
)

export default component.exports